var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "backgroundGrey" },
    [
      _vm.coVisible ? _c("app-navigation") : _vm._e(),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "hide-overlay": "", persistent: "", width: "300" },
          model: {
            value: _vm.coDisconnected,
            callback: function($$v) {
              _vm.coDisconnected = $$v
            },
            expression: "coDisconnected"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "primary", dark: "" } },
            [
              _c("v-card-text", { attrs: { "text-xs-center": "" } }, [
                _c("h4", {
                  domProps: { textContent: _vm._s(_vm.$t("LBL_DISCONNECTED")) }
                })
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "text-xs-center" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "white" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v(_vm._s(_vm.$t("BTN_OK")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "white" },
                      on: { click: _vm.handleReload }
                    },
                    [_vm._v(_vm._s(_vm.$t("BTN_RELOAD")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7562f6f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7562f6f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/app/template.html
// module id = null
// module chunks = 